import { getPageCategory, getTripleID } from "./common"
export const trackWellcomeClickEvent = () => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "about_wellcome_click",
      page_title: document.title,
      page_category: getPageCategory(),
      page_url: window.location.href,
      ...getTripleID()
    })
  }
}
export const trackShippingInfo = newAddress => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "add_address",
      ecommerce: {
        shipping_address: newAddress.address
      }
    })
  }
}
